import React, { useRef } from "react";
import { useLocation } from "react-router-dom";
import { useEffect, useState, useMemo } from "react";
import GetApiService from "Components/Api/getapiService.jsx";
import { useAdminData } from "Components/Pages/AdminPanel/AdminSettings/useAdminData";
import { ClipLoader } from "react-spinners";
import ErrorModal from "Components/Other Functions/popup";
import { AddStockFields } from "Components/Pages/Gdev/Trading/addstock";
import { toPlainFields } from "Components/support/Allfields/fieldconverter";
import AdminHeading from "Components/Pages/AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "Components/Pages/AdminPanel/Heading/AdminBreadCrump";
import { useSelector } from "react-redux";
import AddStockGridSection from "Components/Pages/Gdev/Trading/AddStockGridSection";
import style from "Components/Pages/Gdev/Trading/AdminAddBulkStockNew.module.css";
import SingleStonePopUp from "Components/Pages/Gdev/Support/SingleStonePopUp";
import SingleDiamondPopup from "Components/Pages/Gdev/Support/SingleDiamondPopup";
import useStockTypeEffect from "Components/Pages/Gdev/Trading/useStockTypeEffect";
import ProductFilter from "Components/Pages/Gdev/Trading/ProductFilter";
import { Icon } from "@iconify/react";
import { a177 } from "Components/Api/RootApiPath";
import PayLoadService from "Components/Api/PayLoadServices";
import Imagepopup from "Components/Pages/Gdev/Trading/Imagepopup"
import { GenerateLabel } from "Components/Other Functions/GenerateLabel";


export default function BulkProductEdit() {

    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState(null);
    const [showModal, setShowModal] = useState(false); // Modal visibility state
    // const allStates = useSelector((state) => state);
    // const adminLoggedIn = allStates.reducer1;

    const allStates = useSelector((state) => state);
    const adminLoggedIn = allStates.reducer1;
    //   let Entryby_Staff_id = parseInt(adminLoggedIn);
    const clientCode = adminLoggedIn.ClientCode;
    const employeeCode = adminLoggedIn.EmployeeCode;
    const employeedid = adminLoggedIn.EmployeeId;
    const CompanyId = adminLoggedIn.CompanyId;
    const BranchId = adminLoggedIn.BranchId;
    const CounterId = adminLoggedIn.CounterId;
    const labelFormat = parseInt(adminLoggedIn.Clients.LabelFormat);
    const dbname = adminLoggedIn.Clients.OrganisationName;

    //main data array
    const [productTypeData, setProductTypeData] = useState([]);
    const [StockType, setStockType] = useState("Labelled");
    const [selectedcategory, setSelectedCategory] = useState('')
    const [categoriesData, setCategoriesData] = useState([]);
    const [purityData, setPurityData] = useState([]);
    const [partyData, setPartyData] = useState([]);
    const [boxData, setBoxData] = useState([]);
    const [collectionTypeData, setCollectionTypeData] = useState([]);
    const [collectionmainlist, setCollectionmainlist] = useState([]);
    const [branchOption, setBranchOption] = useState([]);
    const [stonemaster, setStonemaster] = useState([]);
    const [rifdData, setRifdData] = useState([]);
    const [allDiamondSizeWeightRate, setAllDiamondSizeWeightRate] = useState([]);
    const [allDiamondAttributes, setAllDiamondAttributes] = useState([]);
    const [allLabelledStockData, setAllLabelledStockData] = useState([]);

    const [popupVisible, setPopupVisible] = useState("close"); // To control popup visibility

    const location = useLocation();
    const selectedProducts = location.state?.selectedProducts || [];


    const [AddedProducts, setAddedProducts] = useState([]);
    const [allPacketNumbers, setAllPacketNumbers] = useState([]);
    const [allSku, setAllSku] = useState([]);

    const [selectedImages2, setSelectedImages2] = useState([]); // modal imag select
    const [StockKeepingUnit, setSkuValue] = useState("");
    const [Branch, setBranch] = useState("");
    const [allPurchaseItems, setAllPurchaseItems] = useState([]);
    const [allFilteredPurchaseItems, setAllFilteredPurchaseItems] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);

    const [addStone, setAddStone] = useState({
        StoneName: "",
        StoneWeight: 0,
        StonePieces: 0,
        StoneRate: 0,
        StoneAmount: 0,
        Description: "",
        ClientCode: "",
        EmployeeCode: "",
        ProductId: 0,
    });
    const [addDiamond, setAddDiamond] = useState({
        DiamondName: "",
        DiamondWeight: 0,
        DiamondRate: 0,
        DiamondPieces: 0,
        DiamondClarity: "",
        DiamondColour: "",
        DiamondCut: "",
        DiamondShape: "",
        DiamondSize: 0,
        Certificate: "",
        SettingType: "",
        DiamondAmount: 0,
        DiamondPurchaseAmt: 0,
        Description: "",
    });
    const focusableRefs = useRef([]);


    // const {
    //     clientCode,
    //     CompanyId,
    //     CounterId,
    //     BranchId,
    //     EmployeId,
    //     employeeCode,
    //     rdPurchaseFormat,
    // } = useAdminData();


    const apiService = new GetApiService(clientCode);


    const loadData = async () => {
        setLoading(true);
        try {
            const apiCalls = [

                apiService.fetchAllCategories(),
                apiService.fetchAllBranches(),
                apiService.fetchAllProductType(),
                apiService.fetchAllPurities(),
                apiService.fetchAllCustomers(),
                apiService.fetchAllDesigns(),
                apiService.fetchAllBoxs(),
                apiService.fetchAllRdPurchaseItems(),
                apiService.fetchAllPacketNumbers(),
                apiService.fetchAllSku(),
                apiService.fetchAllDiamondSizeWeightRate(),
                apiService.fetchAllDiamondAttributes(),
                apiService.fetchAllCollection(),
                apiService.fetchAllStonesList(),
                apiService.fetchAllRfid(),

                apiService.fetchAllLabelledStock(),

                apiService.fetchPaginatedData({
                    ClientCode: clientCode,
                    CategoryId: 0,
                    DesignId: 0,
                    ProductId: 0,
                    PurityId: 0,
                    Status: "all",
                    Id: 0, // Initial ID (will be overwritten in the method)
                    Size: "500", // Number of items per page
                    UpdatedFrom: "Web",
                }),

            ];

            const results = await Promise.allSettled(apiCalls);

            results.forEach((result, index) => {
                if (result.status === "fulfilled") {
                    // Handle successful response
                    switch (index) {


                        case 0:
                            console.log("checking category ", result);
                            if (Array.isArray(result.value)) {
                                // Check if the first item's CategoryName is 'Gold'
                                if (
                                    result.value.length > 0 &&
                                    result.value[0].CategoryName !== "GOLD"
                                ) {
                                    setCategoriesData(result.value.reverse());
                                } else {
                                    // Set data as-is (without reversing) if the first item is 'Gold'
                                    setCategoriesData(result.value);
                                }
                            } else {
                                setErrorMessage(
                                    "Error: Unexpected response format for Categories."
                                );
                            }
                            break;
                        case 1:
                            setBranchOption(result.value);
                            if (result.value.length > 0) {
                                setBranch(result.value[0].BranchName);
                            }
                            break;
                        case 2:
                            setProductTypeData(result.value);
                            break;
                        case 3:
                            setPurityData(result.value);
                            break;
                        case 4:
                            setPartyData(result.value);
                            break;
                        case 5:
                            setCollectionTypeData(result.value);
                            break;
                        case 6:
                            setBoxData(result.value);
                            break;
                        case 7:
                            setAllPurchaseItems(result.value);
                            setAllFilteredPurchaseItems(result.value);
                            break;
                        case 8:
                            setAllPacketNumbers(result.value);
                            break;
                        case 9:
                            setAllSku(result.value);
                            break;
                        case 10:
                            setAllDiamondSizeWeightRate(result.value);
                            break;
                        case 11:
                            setAllDiamondAttributes(result.value);
                            console.log("check diamondattribute  ", result.value);
                            break;

                        case 12:
                            setCollectionmainlist(result.value);
                            console.log("check allcollections ", result.value);
                            break;
                        case 13:
                            setStonemaster(result.value);
                            console.log("check allstones ", result.value);
                            break;
                        case 14:
                            setRifdData(result.value);
                            console.log("check allrfid  ", result.value);
                            break;
                        case 15:
                            console.log('check all data', result.value)
                            setAllLabelledStockData(result.value);

                            // let data = result.value;

                            // let branchProducts = data;
                            // console.log(branchProducts, "branchProducts");
                            // // Add a serial number property to each product
                            // if (selectBranch === "Home" || selectBranch === "Branch 2") {
                            //     branchProducts = data.filter((x) => x.BranchName === selectBranch);
                            // } else {
                            //     branchProducts = data;
                            // }

                            // const activeProducts = branchProducts.filter((product) => product.Status === "Active");

                            // console.log('check all active', activeProducts)

                            // // Add a serial number property to each product
                            // const productsWithSerial = activeProducts.map((product, index) => ({
                            //     ...product,
                            //     serialNumber: index + 1,
                            // }));
                            // setAllProducts(productsWithSerial.reverse());
                            // //   setAllProducts(data.data);
                            // setDeleteSelected(false);
                            // console.log(productsWithSerial, "productsWithSerial");
                            break;

                        default:
                            break;
                    }
                } else {
                    if (index + 1 > 1) {
                        console.error(
                            `Error loading data for API ${index + 1}:`,
                            result.reason
                        );
                        handleError(
                            `Failed to load data for API ${index + 1}: ${result.reason}`
                        );
                    }
                }
            });
        } catch (error) {
            console.error("Error loading data:", error);
            handleError("Error loading data. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, [clientCode]);

    const getFieldValue = (key, place) => {
        const field = itemfields.find((f) => f.key === key && f.place === place);

        return field ? parseInt(field.value) : undefined; // Return the value or undefined if not found
    };

    const getFieldValueBottom = (key, rowIndex) => {
        if (!Array.isArray(AddedProducts)) {
            console.error("addproducts is not an array");
            return undefined;
        }

        if (rowIndex < 0 || rowIndex >= AddedProducts.length) {
            console.error("rowIndex is out of bounds");
            return undefined;
        }

        const row = AddedProducts[rowIndex];
        if (row && key in row) {
            return row[key];
        } else {
            console.error(`Key '${key}' does not exist in the object at rowIndex ${rowIndex}`);
            return undefined;
        }
    }

    const getFielddValue = (key) => {
        const field = itemfields.find((f) => f.key === key && f.place === "middle");
        return field && field.value ? parseInt(field.value, 10) : 0; // Ensure integer value or default to 0
    };
    useEffect(() => {

        const selectedIds = selectedProducts.map((product) => product.id);

        // Filter allLabelledStockData to find matching IDs
        // const matchingProducts = allLabelledStockData.filter((product) =>
        //     selectedProducts.some(product.Id)
        // );


        const matchingProducts = allLabelledStockData.filter((product) =>
            selectedProducts.some((selected) => parseInt(selected.Id) === parseInt(product.Id)) // ✅ Corrected
        );

        const processedMatchingProducts = matchingProducts.map((product) => {
            // Check if the product has Images and split them by comma
            if (product.Images) {
                // const imagefile = product.Images.split(',').map((image) => image.trim());
                const imagefile = product.Images.split(',').map((image) => {
                    // Extract image path from each image string (assumes format similar to the one you provided)
                    const imagePath = image.trim(); // Example: cbb9ca98-8336-4fe3-b782-55a7911a6810DGO.jpeg
                    // Build the full URL using the DB name (replace `dbName` with actual DB name)
                    const imageUrl = `https://testing.loyalstring.co.in/${dbname}/ProductImage/${imagePath}`;
                    return imageUrl; // Replace with the actual image URL
                });
                return {
                    ...product,
                    imagefile, // Assign the split image URLs to imagefile
                };
            }
            return product; // If no Images, return the product as is
        });

        // Add matching products to AddedProducts
        setAddedProducts((prevAddedProducts) => [
            ...prevAddedProducts,
            ...processedMatchingProducts,
        ]);
        console.log("Selected Products:", selectedProducts, '    ', matchingProducts);
        console.log("Selected Products:1 ", allLabelledStockData);
        console.log("Selected Products  2  :", matchingProducts);
    }, [selectedProducts, allLabelledStockData]);

    const apifields = useMemo(
        () =>
            adminLoggedIn.Modules.filter(
                (module) => module.PageName === "add_bulk_stock_new"
            ),
        [adminLoggedIn]
    );

    const localfields = useMemo(() => toPlainFields(AddStockFields), []);
    const apifieldsControls = useMemo(
        () => apifields[0]?.PageControls || [],
        [apifields]
    );

    const [itemfields, setItemfields] = useState(() => {
        const updatedFields = localfields.map((localField) => {
            const matchingApiField = apifieldsControls.find(
                (apiField) =>
                    apiField.key === localField.key && apiField.place === localField.place
            );
            if (matchingApiField) {
                return {
                    ...localField,
                    label: matchingApiField.label,
                    placeholder: matchingApiField.placeholder,
                    priority: matchingApiField.priority,
                    type: localField.type,
                    visibility: matchingApiField.visibility,
                    place: matchingApiField.place,
                    value: "",
                };
            }
            return localField;
        });

        console.log("check update fields ", updatedFields);

        return updatedFields;
    });


    const handleError = (message) => {
        setErrorMessage(message);
        setShowModal(true); // Open the modal
    };
    const reloadData = () => {
        setShowModal(false); // Close the modal
        loadData(); // Reload data
    };

    const handleKeyDown = (event) => {
        const { key } = event;
    }

    useStockTypeEffect(StockType, itemfields, setItemfields, categoriesData, apifieldsControls, selectedcategory);



    //filters


    const filterSuppliers = () => {

        const LotNumber = getFieldValue('VendorId', 'top')
        const sup = getFieldValue('VendorId', 'top')

        if (LotNumber && LotNumber !== "0") {
            let filteredItems = allPurchaseItems.filter(
                (item) => item.LotNumber === LotNumber
            );

            // Filter `allPurchaseItems` based on `LotNumber`
            if (filteredItems.length > 0) {
                const vendorId = filteredItems[0].VendorId;

                // Filter `partyData` based on the VendorId
                const filteredSupplier = partyData.filter(
                    (party) => party.Id === vendorId
                );

                // Return the filtered suppliers
                return filteredSupplier;
            }
        }
        console.log("check filtered supplier", StockKeepingUnit);

        if (StockKeepingUnit && StockKeepingUnit !== "") {
            // const lotlist = partyData.filter((item) => item.SKU === StockKeepingUnit)
            // console.log('check filtered items1', lotlist);

            // const filteredSkus = allSku.filter((sku) =>
            //   sku.SKUVendor.some((vendor) => vendor.VendorName === Supplier)
            // );

            const filteredsku = allSku.filter(
                (sku) => sku.Id === StockKeepingUnit
            );

            const skuvendorIds = filteredsku.flatMap((sku) =>
                sku.SKUVendor.map((vendor) => vendor.VendorId)
            );

            // Filter suppliers whose Id matches any VendorId in SKUVendor
            const filteredsupplier = partyData.filter((supplier) =>
                skuvendorIds.includes(supplier.Id)
            );

            console.log("Filtered suppliers:", filteredsupplier);

            return filteredsupplier;
        }

        return partyData;
    };

    // Example usage
    const filteredSupplier = filterSuppliers();
    const filterSku = (place, rowIndex) => {

        if (place === 'bottom') {
            const sup = getFieldValueBottom('VendorId', rowIndex)
            const LotNumber = getFieldValue('VendorId', place)
            console.log('check filtervendorb  ', sup);

            if (LotNumber && LotNumber !== "0") {
                // Filter `allPurchaseItems` based on `LotNumber`
                let filteredItems = allPurchaseItems.filter(
                    (item) => item.LotNumber === LotNumber
                );
                if (filteredItems.length > 0) {
                    const skuidList = filteredItems.map((item) => item.SKUId);

                    // Filter allSku where `allSku.Id` matches any `filteredItem.SKUId`
                    const filteredsku = allSku.filter((sku) => skuidList.includes(sku.Id));

                    if (Supplier && Supplier !== "") {
                        const filteredSkus = allSku.filter((sku) =>
                            sku.SKUVendor.some((vendor) => vendor.VendorName === Supplier)
                        );

                        // Return the filtered SKUs
                        return filteredSkus;
                    }

                    // Return the filtered SKUs
                    return filteredsku;
                }
            }

            if (sup && sup !== "") {
                const filteredSkus = allSku.filter((sku) =>
                    sku.SKUVendor.some((vendor) => vendor.VendorId === sup)
                );

                console.log('check filtersku ', allSku);

                // Return the filtered SKUs
                return filteredSkus;
            }

        } else {
            const sup = getFieldValue('VendorId', place)
            const LotNumber = getFieldValue('VendorId', place)
            console.log('check filtervendor  ', sup);

            if (LotNumber && LotNumber !== "0") {
                // Filter `allPurchaseItems` based on `LotNumber`
                let filteredItems = allPurchaseItems.filter(
                    (item) => item.LotNumber === LotNumber
                );
                if (filteredItems.length > 0) {
                    const skuidList = filteredItems.map((item) => item.SKUId);

                    // Filter allSku where `allSku.Id` matches any `filteredItem.SKUId`
                    const filteredsku = allSku.filter((sku) => skuidList.includes(sku.Id));

                    if (Supplier && Supplier !== "") {
                        const filteredSkus = allSku.filter((sku) =>
                            sku.SKUVendor.some((vendor) => vendor.VendorName === Supplier)
                        );

                        // Return the filtered SKUs
                        return filteredSkus;
                    }

                    // Return the filtered SKUs
                    return filteredsku;
                }
            }

            if (sup && sup !== "") {
                const filteredSkus = allSku.filter((sku) =>
                    sku.SKUVendor.some((vendor) => vendor.VendorId === sup)
                );

                console.log('check filtersku ', allSku);

                // Return the filtered SKUs
                return filteredSkus;
            }
        }




        return allSku;
    };


    const productFilter = new ProductFilter(
        productTypeData,
        purityData,
        collectionTypeData,
        AddedProducts,
        getFieldValue
    );
    const filteredProducts = (place, rowIndex) => {
        const filtered = productFilter.filterProducts(place, rowIndex);
        console.log("Filtered Products:", filtered);
        return filtered;

    };
    const filteredPurity = (place, rowIndex) => {
        const filtered = productFilter.filterPurity(place, rowIndex);
        console.log("Filtered Purity:", filtered);
        return filtered;
    };

    const filteredDesigns = (place, rowIndex) => {
        const filtered = productFilter.filterDesigns(place, rowIndex);
        console.log("Filtered Designs:", filtered);
        return filtered;
    };
    const handlepopup = (key, place, rowIndex) => {



        if (place === 'bottom') {
            if (key === 'stones') {
                console.log('checking popupbtn before ', AddedProducts[rowIndex].Stones);

                const sku = AddedProducts[rowIndex].SKUId;

                const skuitem = allSku.find((s) => s.Id === sku);

                console.log('checking sku ', skuitem);

                if (skuitem?.SKUStoneMain) {
                    const updatedStonemaster = stonemaster?.length
                        ? stonemaster.filter((stone) => !stone.isFromSKU)
                        : [];

                    const newStones = skuitem.SKUStoneMain.map((stoneMain) => ({
                        ...stoneMain,
                        StoneName: stoneMain.StoneMainName,
                        StoneWeight: stoneMain.StoneMainWeight,
                        StonePieces: stoneMain.StoneMainPieces,
                        StoneRatePiece: 0,
                        StoneRateKarate: stoneMain.StoneMainRate,
                        StoneRate: stoneMain.StoneMainRate,
                        StoneAmount: stoneMain.StoneMainAmount,
                        Description: stoneMain.StoneMainDescription,
                        isFromSKU: true, // Mark new stones as SKU-specific
                    }));
                    console.log('skuitemstones  ', newStones);
                    setStonemaster([...updatedStonemaster, ...newStones]);
                }



                if (AddedProducts[rowIndex].Stones && AddedProducts[rowIndex].Stones.length > 0) {
                    // If Stones exists and is not empty, trigger popup
                    setSelectedRow(rowIndex)
                    setTimeout(() => {
                        setPopupVisible('stones');
                    }, 0);
                } else {

                    // Otherwise, add a new stone to the item
                    setAddedProducts((prevProducts) =>
                        prevProducts.map((item, i) =>

                            i === rowIndex
                                ? {
                                    ...item,
                                    Stones:
                                        item.Stones && item.Stones.length > 0
                                            ? item.Stones // Keep existing Stones as they are
                                            : [addStone], // Add addStone only if Stones is empty or undefined
                                }
                                : item
                        )
                    );
                    setSelectedRow(rowIndex)
                    setTimeout(() => {
                        setPopupVisible('stones');
                    }, 0);
                    console.log('checking popupbtn ', AddedProducts);
                }
            } else if (key === 'diamond') {
                if (AddedProducts[rowIndex].Diamonds && AddedProducts[rowIndex].Diamonds.length > 0) {
                    // If Stones exists and is not empty, trigger popup
                    setSelectedRow(rowIndex)
                    setTimeout(() => {
                        setPopupVisible('diamonds');
                    }, 0);
                } else {

                    // Otherwise, add a new stone to the item
                    setAddedProducts((prevProducts) =>
                        prevProducts.map((item, i) =>

                            i === rowIndex
                                ? {
                                    ...item,
                                    Diamonds:
                                        item.Diamonds && item.Diamonds.length > 0
                                            ? item.Diamonds // Keep existing Stones as they are
                                            : [addDiamond], // Add addStone only if Stones is empty or undefined
                                }
                                : item
                        )
                    );
                    setSelectedRow(rowIndex)
                    setTimeout(() => {
                        setPopupVisible('diamonds');
                    }, 0);
                    console.log('checking popupbtn ', AddedProducts);
                }
            }
            else if (key === 'images') {
                setSelectedRow(rowIndex)
                setTimeout(() => {
                    setPopupVisible('images');
                }, 0);
                console.log('checking popupbtn ', AddedProducts);
            }
        }

    }

    const handlegriddropdown = (key, e, rowIndex) => {

        const value = e.target.value;

        if (key === 'SKU') {


            if (allSku && Array.isArray(allSku)) {
                const selectedsku = allSku.find((s) => s.Id === parseInt(value));
                console.log('check grid change', selectedsku);

                if (selectedsku) {
                    // Do something with selectedsku if found
                    setAddedProducts((prevProducts) =>
                        prevProducts.map((row, currentRowIndex) => {
                            if (currentRowIndex !== rowIndex) return row;
                            let updatedRow = { ...row };

                            updatedRow[key] = value;
                            updatedRow['SKUId'] = ''


                            return updatedRow;
                        }))

                } else {
                    console.log('SKU not found');
                    setAddedProducts((prevProducts) =>
                        prevProducts.map((row, currentRowIndex) => {
                            if (currentRowIndex !== rowIndex) return row;
                            let updatedRow = { ...row };

                            updatedRow[key] = '';
                            updatedRow['SKUId'] = ''



                            return updatedRow;
                        }))
                }
            } else {
                console.log('allSku is not defined or not an array'); setAddedProducts((prevProducts) =>
                    prevProducts.map((row, currentRowIndex) => {
                        if (currentRowIndex !== rowIndex) return row;
                        let updatedRow = { ...row };

                        updatedRow[key] = '';
                        updatedRow['SKUId'] = ''


                        return updatedRow;
                    }))
            }

            return;
        }

        setAddedProducts((prevProducts) =>
            prevProducts.map((row, currentRowIndex) => {
                if (currentRowIndex !== rowIndex) return row;
                let updatedRow = { ...row };

                updatedRow[key] = value;



                return updatedRow;
            }))

    }

    const handlegridinput = (key, e, rowIndex) => {

        console.log('checking all keyatgrid ', key);
        const value = e.target.value;
        setAddedProducts((prevProducts) =>
            prevProducts.map((row, currentRowIndex) => {
                if (currentRowIndex !== rowIndex) return row;
                let updatedRow = { ...row };

                updatedRow[key] = value;

                if (
                    [
                        "GrossWt",
                        "TotalStoneWeight",
                        "PackingWeight",
                        "ClipQuantity",
                        "ClipWeight",
                        "PackingWeight",
                        "OtherWeight",
                        "PouchWeight",
                        "TagWeight",
                        "FindingWeight",
                        "LanyardWeight",
                        "TotalWeight",
                    ].includes(key)
                ) {
                    const grossWt =
                        key === "GrossWt"
                            ? parseFloat(value)
                            : parseFloat(row.GrossWt || 0);
                    const stoneWt =
                        key === "TotalStoneWeight"
                            ? parseFloat(value)
                            : parseFloat(row.TotalStoneWeight || 0);
                    const packingWt =
                        key === "PackingWeight"
                            ? parseFloat(value)
                            : parseFloat(row.PackingWeight || 0);
                    const clipQty =
                        key === "ClipQuantity"
                            ? parseFloat(value)
                            : parseFloat(row.ClipQuantity || 1);
                    const clipWt =
                        key === "ClipWeight"
                            ? parseFloat(value)
                            : parseFloat(row.ClipWeight || 0);
                    const tweight =
                        key === "TotalWeight"
                            ? parseFloat(value)
                            : parseFloat(row.TotalWeight || 0);
                    const otherweight =
                        key === "OtherWeight"
                            ? parseFloat(value)
                            : parseFloat(row.OtherWeight || 0);
                    const pouchweight =
                        key === "PouchWeight"
                            ? parseFloat(value)
                            : parseFloat(row.PouchWeight || 0);
                    const tagweight =
                        key === "TagWeight"
                            ? parseFloat(value)
                            : parseFloat(row.TagWeight || 0);
                    const findweight =
                        key === "FindingWeight"
                            ? parseFloat(value)
                            : parseFloat(row.FindingWeight || 0);
                    const lanyweight =
                        key === "LanyardWeight"
                            ? parseFloat(value)
                            : parseFloat(row.LanyardWeight || 0);

                    if (value !== '') {
                        if (
                            [
                                grossWt,
                                stoneWt,
                                packingWt,
                                clipQty,
                                clipWt,
                                otherweight,
                                pouchweight,
                                tagweight,
                                findweight,
                            ].some((val) => isNaN(val))
                        ) {
                            alert(
                                "Error: Invalid input detected. Please provide numeric values."
                            );
                            return row; // Skip updating this row if the input is invalid
                        }
                    }
                    const totalClipWt = clipQty * clipWt;
                    if (key === "GrossWt") {
                        const n = grossWt - stoneWt;
                        const tw = grossWt + packingWt;
                        updatedRow = {
                            ...updatedRow,
                            // GrossWt: g.toFixed(2),
                            NetWt: n.toFixed(2),
                            TotalWeight: tweight > 0 ? tw : 0,
                        };
                    } else if (key === "TotalStoneWeight") {
                        const n = grossWt - stoneWt;
                        updatedRow = {
                            ...updatedRow,
                            // GrossWt: g.toFixed(2),
                            NetWt: n.toFixed(2),
                        };
                    } else if (key === "PackingWeight") {
                        if (packingWt > tweight) {
                            updatedRow = {
                                ...updatedRow,
                                PackingWeight: 0, // Reset PackingWeight
                            };

                            // Replace alert with a user-friendly notification
                            alert("Packing weight cannot be more than the total weight."); // Hypothetical function for showing errors

                            console.error(
                                "Invalid PackingWeight: Packing weight exceeds total weight."
                            );

                            // return; // Stop further execution
                        } else {
                            if (packingWt > 0 && tweight > 0) {
                                const g = tweight - packingWt;
                                const n = g - stoneWt;
                                updatedRow = {
                                    ...updatedRow,
                                    GrossWt: g.toFixed(2),
                                    NetWt: n.toFixed(2),
                                };

                                // handleVisibilityChange(key)
                                handleVisibilityChange(key, "ReadOnly");
                            }
                        }
                    } else if (key === "ClipQuantity") {
                        // if(totalClipWt > 0){

                        const tpacking =
                            totalClipWt +
                            otherweight +
                            pouchweight +
                            tagweight +
                            findweight +
                            lanyweight;

                        const tw = tpacking + grossWt;
                        // handleVisibilityChange(key)
                        updatedRow = {
                            ...updatedRow,
                            PackingWeight: tpacking,
                            TotalWeight: tw,
                        };
                        handleVisibilityChange(key, "ReadOnly");

                        // }
                    } else if (key === "ClipWeight") {
                        if (totalClipWt > 0) {
                            // handleVisibilityChange(key)
                            const tpacking =
                                totalClipWt +
                                otherweight +
                                pouchweight +
                                tagweight +
                                findweight +
                                lanyweight;
                            const tw = tpacking + grossWt;
                            // handleVisibilityChange(key)
                            updatedRow = {
                                ...updatedRow,
                                PackingWeight: tpacking,
                                TotalWeight: tw,
                            };
                            handleVisibilityChange(key, "ReadOnly");
                        }
                    } else if (key === "TotalWeight") {
                        if (tweight > 0) {
                            const t = tweight - packingWt;
                            const n = t - stoneWt;

                            // const n = g - stoneWt;
                            updatedRow = {
                                ...updatedRow,
                                // PackingWeight: 0,
                                GrossWt: t,
                                NetWt: n,
                            };
                        } else {
                            updatedRow = {
                                ...updatedRow,
                                PackingWeight: 0,
                                GrossWt: 0,
                                NetWt: 0,
                                TotalWeight: 0,
                            };
                        }

                        // handleVisibilityChange(key, 'ReadOnly')
                    } else if (key === "OtherWeight") {
                        // if(otherweight > 0){
                        // handleVisibilityChange(key)
                        const tpacking =
                            totalClipWt +
                            otherweight +
                            pouchweight +
                            tagweight +
                            findweight +
                            lanyweight;
                        const tw = tpacking + grossWt;
                        // handleVisibilityChange(key)
                        updatedRow = {
                            ...updatedRow,
                            PackingWeight: tpacking,
                            TotalWeight: tw,
                        };
                        handleVisibilityChange(key, "ReadOnly");
                        // }
                    } else if (key === "PouchWeight") {
                        // if(pouchweight > 0){
                        console.log("checking packing weight  ", pouchweight);

                        // handleVisibilityChange(key)
                        const tpacking =
                            totalClipWt +
                            otherweight +
                            pouchweight +
                            tagweight +
                            findweight +
                            lanyweight;
                        const tw = tpacking + grossWt;
                        // handleVisibilityChange(key)
                        updatedRow = {
                            ...updatedRow,
                            PackingWeight: tpacking,
                            TotalWeight: tw,
                        };
                        handleVisibilityChange(key, "ReadOnly");
                        // }else{

                        // }
                    } else if (key === "TagWeight") {
                        // if(tagweight > 0){
                        // handleVisibilityChange(key)
                        const tpacking =
                            totalClipWt +
                            otherweight +
                            pouchweight +
                            tagweight +
                            findweight +
                            lanyweight;
                        const tw = tpacking + grossWt;
                        // handleVisibilityChange(key)
                        updatedRow = {
                            ...updatedRow,
                            PackingWeight: tpacking,
                            TotalWeight: tw,
                        };
                        handleVisibilityChange(key, "ReadOnly");
                        // }
                    } else if (key === "FindingWeight") {
                        // if(findweight > 0){
                        // handleVisibilityChange(key)
                        const tpacking =
                            totalClipWt +
                            otherweight +
                            pouchweight +
                            tagweight +
                            findweight +
                            lanyweight;
                        const tw = tpacking + grossWt;
                        // handleVisibilityChange(key)
                        updatedRow = {
                            ...updatedRow,
                            PackingWeight: tpacking,
                            TotalWeight: tw,
                        };
                        handleVisibilityChange(key, "ReadOnly");
                        // }
                    } else if (key === "LanyardWeight") {
                        // if(lanyweight > 0){
                        // handleVisibilityChange(key)
                        const tpacking =
                            totalClipWt +
                            otherweight +
                            pouchweight +
                            tagweight +
                            findweight +
                            lanyweight;
                        const tw = tpacking + grossWt;
                        // handleVisibilityChange(key)
                        updatedRow = {
                            ...updatedRow,
                            PackingWeight: tpacking,
                            TotalWeight: tw,
                        };
                        handleVisibilityChange(key, "ReadOnly");
                        // }
                    } else {
                    }


                    if (["MakingPercentage", "WastagePercent"].includes(key)) {
                        updatedRow.MakingPercentage = value;
                        updatedRow.WastagePercent = value;
                    }

                } else if (key === "RFIDCode") {
                    const barcodeValue = value.toUpperCase();
                    updatedRow.RFIDCode = barcodeValue;
                    console.log('checking all items ', allLabelledStockData);


                    const isBarcodeInUse = allLabelledStockData.some(
                        (item) => item.RFIDCode === barcodeValue && item.Status !== "Sold"
                    );

                    if (isBarcodeInUse) {
                        alert(
                            `Barcode ${barcodeValue} is already in use for another product.`
                        );
                        updatedRow.RFIDCode = ""; // Clear RFIDCode if duplicate
                    } else {
                        const matchingProduct = rifdData?.find(
                            (item) => item.BarcodeNumber === barcodeValue
                        );
                        updatedRow.TIDNumber = matchingProduct
                            ? matchingProduct.TidValue
                            : null;
                    }
                }

                return updatedRow;
            }))

    }

    const handleVisibilityChange = (key, visible) => {
        if (key === "PackingWeight") {
          setItemfields((prevFields) =>
            prevFields.map((field) => {
              if (
                [
                  "ClipQuantity",
                  "ClipWeight",
                  "OtherWeight",
                  "PouchWeight",
                  "TagWeight",
                  "FindingWeight",
                ].includes(field.key) &&
                field.place === "grid"
              ) {
                return {
                  ...field,
                  visibility: visible, // Ensure other fields in the grid remain editable
                };
              }
              return field;
            })
          );
        } else if (
          [
            "ClipQuantity",
            "ClipWeight",
            "OtherWeight",
            "PouchWeight",
            "TagWeight",
            "FindingWeight",
          ].includes(key)
        ) {
          setItemfields((prevFields) =>
            prevFields.map((field) => {
              if (field.key === "PackingWeight" && field.place === "grid") {
                return {
                  ...field,
                  visibility: visible, // Ensure PackingWeight remains editable in the grid
                };
              }
              return field;
            })
          );
        }
      };

    const handleClosePopup = () => {
        setPopupVisible("close"); // Hide the popup
        setSelectedRow(null); // Clear selected row
        // const nextElement = focusableRefs.current.gridSectionRefs[selectedRow * columnCount + columnIndex+1]; // Assuming you have a grid

        // console.log('check next element ', nextElement);

        // if (nextElement) {
        //   nextElement.focus();
        // }

        const gridRefs = focusableRefs.current.gridSectionRefs;

        if (gridRefs) {
            // Find the next focusable element that is not disabled or read-only
            const nextElement = gridRefs.find((element, index) => {
                return (
                    index > selectedRow * columnCount + columnIndex && // Must be after the current element
                    element && // Ensure the element exists
                    !element.disabled && // Not disabled
                    !element.readOnly // Not read-only
                );
            });

            console.log("Next enabled element:", nextElement);

            // Focus on the next enabled element if it exists
            if (nextElement) {
                nextElement.focus();
            }
        }
    };

    const handleSavePopup = (updatedDetails, type) => {
        // Clone the products array
        const updatedProducts = [...AddedProducts];
        console.log("Checking updated items: ", updatedProducts);
        console.log("Selected row index: ", selectedRow);

        // Calculate total weight and amount for the updated details
        const totalWeight = updatedDetails.reduce(
            (total, item) =>
                total + (parseFloat(item[type === "diamond" ? "DiamondWeight" : "StoneWeight"]) || 0),
            0
        );
        const totalAmount = updatedDetails.reduce(
            (total, item) =>
                total + (parseFloat(item[type === "diamond" ? "DiamondAmount" : "StoneAmount"]) || 0),
            0
        );

        // Get the other weight depending on type
        const otherWeight =
            type === "diamond"
                ? updatedProducts[selectedRow].TotalStoneWeight || 0
                : updatedProducts[selectedRow].TotalDiamondWeight || 0;

        // Calculate NetWt as GrossWt - (totalWeight + otherWeight)
        const netWeight = updatedProducts[selectedRow].GrossWt - (totalWeight + otherWeight);

        // Update the respective fields based on the type
        if (type === "diamond") {
            updatedProducts[selectedRow].Diamonds = updatedDetails;
            updatedProducts[selectedRow].TotalDiamondWeight = totalWeight;
            updatedProducts[selectedRow].TotalDiamondAmount = totalAmount;
        } else {
            updatedProducts[selectedRow].Stones = updatedDetails;
            updatedProducts[selectedRow].TotalStoneWeight = totalWeight;
            updatedProducts[selectedRow].TotalStoneAmount = totalAmount;
        }

        // Update NetWt for the product
        updatedProducts[selectedRow].NetWt = netWeight;

        // Update the state and close the popup
        setAddedProducts(updatedProducts);
        console.log(`Updated ${type === "diamond" ? "diamond" : "stone"} details: `, updatedDetails);
        handleClosePopup();
    };


    const getStonesBySKU = (sku) => {
        // Fetch stones dynamically based on SKU
        const stones = allstonesmiddle.filter(stone => stone.SKU === sku);

        setGridStones(prev => ({
            ...prev,
            [sku]: stones, // Store stones for each SKU
        }));
    };


    const saveall = async () => {
        const errors = [];
        try {
            AddedProducts.forEach((product, index) => {
                const errorsForProduct = [];
    
                if (product.CategoryName === "LOOSE DIAMOND") {
                    if (!product.DiamondShape || product.DiamondShape.trim() === "") {
                        errorsForProduct.push(`Diamond shape is missing.`);
                    }
    
                    if (!product.DiamondClarity || product.DiamondClarity.trim() === "") {
                        errorsForProduct.push(`Diamond clarity is missing.`);
                    }
    
                    if (!product.DiamondColour || product.DiamondColour.trim() === "") {
                        errorsForProduct.push(`Diamond colour is missing.`);
                    }
    
                    if (!product.DiamondCut || product.DiamondCut.trim() === "") {
                        errorsForProduct.push(`Diamond cut is missing.`);
                    }
    
                    // Further checks for Loose Diamond fields...
                } else if (product.CategoryName === "LooseStone") {
                    if (!product.StoneName || product.StoneName.trim() === "") {
                        errorsForProduct.push(`Stone name is missing.`);
                    }
    
                    if (!product.StoneColor || product.StoneColor.trim() === "") {
                        errorsForProduct.push(`Stone color is missing.`);
                    }
    
                    if (!product.StoneShape || product.StoneShape.trim() === "") {
                        errorsForProduct.push(`Stone shape is missing.`);
                    }
    
                    // Further checks for Loose Stone fields...
                } else {
                    // Validate GrossWt
                    if (!product.GrossWt || parseFloat(product.GrossWt) <= 0) {
                        errorsForProduct.push(`Gross weight must be greater than 0.`);
                    }
    
                    // Validate DesignName
                    if (!product.DesignName || product.DesignName.trim() === "") {
                        errorsForProduct.push(`Design name is missing.`);
                    }
    
                    // Validate VendorId
                    if (!product.VendorId) {
                        errorsForProduct.push(`Vendor ID is missing.`);
                    }
    
                    // Validate VendorName
                    if (!product.VendorName || product.VendorName.trim() === "") {
                        errorsForProduct.push(`Vendor name is missing.`);
                    }
    
                    // If there are errors for this product, add them to the errors array
                    if (errorsForProduct.length > 0) {
                        errors.push(`Item ${index + 1}:\n- ${errorsForProduct.join("\n- ")}`);
                    }
                }
    
    
    
            });
    
            // If there are any errors, show an alert with detailed error messages
            if (errors.length > 0) {
                alert(`Please address the following issues:\n\n${errors.join("\n\n")}`);
                console.error("Validation errors:", errors);
                return;
            }
    
            console.log("All items are valid. Proceeding to save...");
    
            let updatedProducts = AddedProducts.map((product) => {
                let updatedProduct = { ...product };
    
                if (!product.WeightCategory) {
                    const selectedSku = allSku.find(
                        (v) => v.StockKeepingUnit === product.SKU
                    );
    
                    if (selectedSku && selectedSku.WeightCategories) {
                        const weightCategoriesArray =
                            selectedSku.WeightCategories.split(",").map(Number);
    
                        const grossWt = parseFloat(product.GrossWt);
                        const weightCategory = findClosestWeightCategory(
                            grossWt,
                            weightCategoriesArray
                        );
    
                        updatedProduct = {
                            ...updatedProduct,
                            WeightCategory: weightCategory || 0,
                        };
                    }
                }
            })


            updatedProducts = await Promise.all(
                AddedProducts.map(async (product) => {
                    let existingImages = product.Images ? product.Images.split(',') : [];
                    let newImages = product.imagefile ? product.imagefile.filter(img => typeof img !== 'string') : [];
    
                    let uploadedImageUrls = [];
    
                    if (newImages.length > 0) {
                        uploadedImageUrls = await uploadImages1(product, newImages);
                    }
    
                    const finalImages = [...existingImages, ...uploadedImageUrls].filter(Boolean).join(',');
    
                    const updatedProduct = {
                        ...product,
                        Images: finalImages, // Update the images field with new and existing images
                        ClientCode: clientCode,
                        EmployeeId: employeedid,
                        EmployeeCode: employeedid,
                        StoneColour: product.StoneColor,
                        CompanyId: 0,
                        CounterId: 0,
                        count: 0,
                        MetalId: 1,
                        WarehouseId: 0,
                        TaxId: 0,
                        DeptId: 0,
                    };
    
                    const {
                        dsleves,
                        importbtn,
                        mainstone,
                        addbtn,
                        images,
                        FinePercent,
                        WastagePercent,
                        FineWastage,
                        EmployeeId,
                        count,
                        TaxId,
                        DeptId,
                        StoneColor,
                        ...cleanedProduct
                    } = updatedProduct;
    
                    return cleanedProduct;
                })
            );
    
            console.log("Checking payload before sending:", updatedProducts);
    
            const payloadService = new PayLoadService();
            const response = await payloadService.sendPayloadupdate(updatedProducts);
    
            console.log("API Response:", response);
            if (Array.isArray(response) && response.length > 0) {
                const processedIds = response.map((item) => item.Id).join(", ");
                GenerateLabel(response, labelFormat);
                setAddedProducts([]);
                setItemfields((prevFields) =>
                    prevFields.map((field) => ({ ...field, value: "" }))
                );
                setSelectedCategory("");
                setStockType("");
            } else if (response.Message) {
                alert(`Message: ${response.Message}`);
            } else {
                alert("Operation completed successfully!");
            }
        } catch (error) {
            console.error("Error saving products:", error);
            alert("An error occurred while saving products.");
        }
    };
    
    const uploadImages1 = async (product, newImages) => {
        const formData = new FormData();
        formData.append("ClientCode", clientCode);
        formData.append("DesignId", product.DesignId);
    
        newImages.forEach((image, index) => {
            if (image.file) {
                formData.append(`file${index + 1}`, image.file);
            }
        });
    
        try {
            const response = await fetch('https://testing.loyalstring.co.in/api/ProductMaster/UploadImagesByClientCode', {
                method: 'POST',
                body: formData,
            });
    
            if (response.ok) {
                const data = await response.json();
                if (data.status === 'Success' && data.images) {
                    return data.images.split(','); // Return new image URLs as an array
                } else {
                    console.error('Image upload failed: ', data);
                    return [];
                }
            } else {
                console.error('Image upload failed with status: ', response.status);
                return [];
            }
        } catch (error) {
            console.error('Error uploading images:', error);
            return [];
        }
    };

    



    const saveallold1 = async () => {
        const errors = [];

        console.log('check added products', AddedProducts);

        AddedProducts.forEach((product, index) => {
            const errorsForProduct = [];

            if (product.CategoryName === "LOOSE DIAMOND") {
                if (!product.DiamondShape || product.DiamondShape.trim() === "") {
                    errorsForProduct.push(`Diamond shape is missing.`);
                }

                if (!product.DiamondClarity || product.DiamondClarity.trim() === "") {
                    errorsForProduct.push(`Diamond clarity is missing.`);
                }

                if (!product.DiamondColour || product.DiamondColour.trim() === "") {
                    errorsForProduct.push(`Diamond colour is missing.`);
                }

                if (!product.DiamondCut || product.DiamondCut.trim() === "") {
                    errorsForProduct.push(`Diamond cut is missing.`);
                }

                // Further checks for Loose Diamond fields...
            } else if (product.CategoryName === "LooseStone") {
                if (!product.StoneName || product.StoneName.trim() === "") {
                    errorsForProduct.push(`Stone name is missing.`);
                }

                if (!product.StoneColor || product.StoneColor.trim() === "") {
                    errorsForProduct.push(`Stone color is missing.`);
                }

                if (!product.StoneShape || product.StoneShape.trim() === "") {
                    errorsForProduct.push(`Stone shape is missing.`);
                }

                // Further checks for Loose Stone fields...
            } else {
                // Validate GrossWt
                if (!product.GrossWt || parseFloat(product.GrossWt) <= 0) {
                    errorsForProduct.push(`Gross weight must be greater than 0.`);
                }

                // Validate DesignName
                if (!product.DesignName || product.DesignName.trim() === "") {
                    errorsForProduct.push(`Design name is missing.`);
                }

                // Validate VendorId
                if (!product.VendorId) {
                    errorsForProduct.push(`Vendor ID is missing.`);
                }

                // Validate VendorName
                if (!product.VendorName || product.VendorName.trim() === "") {
                    errorsForProduct.push(`Vendor name is missing.`);
                }

                // If there are errors for this product, add them to the errors array
                if (errorsForProduct.length > 0) {
                    errors.push(`Item ${index + 1}:\n- ${errorsForProduct.join("\n- ")}`);
                }
            }



        });

        // If there are any errors, show an alert with detailed error messages
        if (errors.length > 0) {
            alert(`Please address the following issues:\n\n${errors.join("\n\n")}`);
            console.error("Validation errors:", errors);
            return;
        }

        console.log("All items are valid. Proceeding to save...");

        let updatedProducts = AddedProducts.map((product) => {
            let updatedProduct = { ...product };

            if (!product.WeightCategory) {
                const selectedSku = allSku.find(
                    (v) => v.StockKeepingUnit === product.SKU
                );

                if (selectedSku && selectedSku.WeightCategories) {
                    const weightCategoriesArray =
                        selectedSku.WeightCategories.split(",").map(Number);

                    const grossWt = parseFloat(product.GrossWt);
                    const weightCategory = findClosestWeightCategory(
                        grossWt,
                        weightCategoriesArray
                    );

                    updatedProduct = {
                        ...updatedProduct,
                        WeightCategory: weightCategory || 0,
                    };
                }
            }





            // Add required fields
            const updatedProductold = {
                ...updatedProduct,
                ClientCode: clientCode,
                EmployeeId: employeedid,
                EmployeeCode: employeedid,
                CompanyId: 0,
                CounterId: 0,
                count: 0,
                MetalId: 1,
                WarehouseId: 0,
                TaxId: 0,
                // Diamonds: [],
                DeptId: 0,
            };

            // Remove unwanted keys
            const {
                dsleves,
                importbtn,
                mainstone,
                addbtn,
                images,
                FinePercent,
                WastagePercent,
                FineWastage,
                EmployeeId,
                count,
                TaxId,
                DeptId,
                ...cleanedProduct
            } = updatedProduct;

            return cleanedProduct;
        });

        try {
            // Upload images for all products concurrently
            //   updatedProducts = await Promise.all(
            //     AddedProducts.map(async (product) => {
            //       const imageUrls = await uploadImages(product);
            //       const updatedProduct = {
            //         ...product,
            //         // image : imageUrls,
            //         ClientCode: clientCode,
            //         EmployeeId: employeedid,
            //         EmployeeCode: employeedid,
            //         StoneColour: product.StoneColor,
            //         CompanyId: 0,
            //         CounterId: 0,
            //         count: 0,
            //         MetalId: 1,
            //         WarehouseId: 0,
            //         TaxId: 0,
            //         DeptId: 0,
            //       };

            //       const {
            //         dsleves,
            //         importbtn,
            //         mainstone,
            //         addbtn,
            //         images,
            //         FinePercent,
            //         WastagePercent,
            //         FineWastage,
            //         EmployeeId,
            //         count,
            //         TaxId,
            //         DeptId,
            //         Images,
            //         StoneColor,
            //         ...cleanedProduct
            //       } = updatedProduct;

            //       return cleanedProduct;
            //     })
            //   );

            updatedProducts = await Promise.all(
                AddedProducts.map(async (product) => {
                    // Check if the product has images
                    if (product.imagefile && product.imagefile.length > 0) {
                        // Upload images only if the product has images
                        const imageUrls = await uploadImages(product);

                        const updatedProduct = {
                            ...product,
                            ClientCode: clientCode,
                            EmployeeId: employeedid,
                            EmployeeCode: employeedid,
                            StoneColour: product.StoneColor,
                            CompanyId: 0,
                            CounterId: 0,
                            count: 0,
                            MetalId: 1,
                            WarehouseId: 0,
                            TaxId: 0,
                            DeptId: 0,
                            // Include uploaded images if available
                            imageUrls, // You can assign the imageUrls to the appropriate field
                        };

                        const {
                            dsleves,
                            importbtn,
                            mainstone,
                            addbtn,
                            images,
                            FinePercent,
                            WastagePercent,
                            FineWastage,
                            EmployeeId,
                            count,
                            TaxId,
                            DeptId,
                            Images,
                            StoneColor,
                            ...cleanedProduct
                        } = updatedProduct;

                        return cleanedProduct;
                    } else {
                        // If no images are available, skip the image upload and just return the product without the imageUrls
                        const updatedProduct = {
                            ...product,
                            ClientCode: clientCode,
                            EmployeeId: employeedid,
                            EmployeeCode: employeedid,
                            StoneColour: product.StoneColor,
                            CompanyId: 0,
                            CounterId: 0,
                            count: 0,
                            MetalId: 1,
                            WarehouseId: 0,
                            TaxId: 0,
                            DeptId: 0,
                        };

                        const {
                            dsleves,
                            importbtn,
                            mainstone,
                            addbtn,
                            images,
                            FinePercent,
                            WastagePercent,
                            FineWastage,
                            EmployeeId,
                            count,
                            TaxId,
                            DeptId,
                            Images,
                            StoneColor,
                            ...cleanedProduct
                        } = updatedProduct;

                        return cleanedProduct;
                    }
                })
            );

            console.log("Checking payload before sending:", updatedProducts);

            const payloadService = new PayLoadService();
            const response = await payloadService.sendPayloadupdate(updatedProducts);

            console.log("API Response:", response);
            if (Array.isArray(response) && response.length > 0) {
                const processedIds = response.map((item) => item.Id).join(", ");
                GenerateLabel(response, labelFormat);
                setAddedProducts([]);
                setItemfields((prevFields) =>
                    prevFields.map((field) => ({ ...field, value: "" }))
                );
                setSelectedCategory("");
                setStockType("");
            } else if (response.Message) {
                alert(`Message: ${response.Message}`);
            } else {
                alert("Operation completed successfully!");
            }
        } catch (error) {
            console.error("Error saving products:", error);
            alert("An error occurred while saving products.");
        }


    };

    const uploadImages = async (product) => {
        const formData = new FormData();
        formData.append("ClientCode", clientCode);
        formData.append("DesignId", product.DesignId);

        const productFiles = product.Images || [];
        console.log('check images uploading ', productFiles, '   ', product);


        productFiles.forEach((image, index) => {
            if (image.file) {
                formData.append(`file${index + 1}`, image.file); // Attach the file
            }
        });

        try {
            const response = await fetch('https://testing.loyalstring.co.in/api/ProductMaster/UploadImagesByClientCode', {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                const data = await response.json();
                if (data.status === 'Success' && data.images) {
                    // const imageUrls = data.images.split(',');
                    // return imageUrls;
                    //   return data.images;
                    const concatenatedImages = product.Images ? product.Images + ',' + data.images : data.images;
                    return concatenatedImages;
                } else {
                    console.error('Image upload failed: ', data);
                    return null;
                }
            } else {
                console.error('Image upload failed with status: ', response.status);
                return null;
            }
        } catch (error) {
            console.error('Error uploading images:', error);
            return null;
        }
    };


    function findClosestWeightCategory(grossWt, weightCategoriesArray) {
        // Sort weight categories in ascending order
        weightCategoriesArray.sort((a, b) => a - b);

        // Initialize closest category with the first element
        let closestCategory = weightCategoriesArray[0];

        // Loop through each category to find the closest
        for (let i = 0; i < weightCategoriesArray.length; i++) {
            let currentCategory = weightCategoriesArray[i];

            // If the grossWt is less than or equal to the current category, assign it
            if (grossWt <= currentCategory) {
                closestCategory = currentCategory;
                break;
            }

            // If the grossWt is slightly higher, find the closest match based on distance
            if (grossWt > currentCategory) {
                if (i < weightCategoriesArray.length - 1) {
                    const nextCategory = weightCategoriesArray[i + 1];

                    if (grossWt <= nextCategory) {
                        closestCategory =
                            grossWt - currentCategory <= nextCategory - grossWt
                                ? currentCategory
                                : nextCategory;
                        break;
                    }
                }
            }
        }

        return closestCategory;
    }

    return (
        <div>
            <div>
                <AdminHeading />

                {loading ? (
                    // Show spinner while loading
                    <div className={style.spinnercontainer}>
                        <ClipLoader size={50} color={"#123abc"} loading={loading} />
                        <p>Loading data...</p>
                    </div>
                ) : (
                    <div>
                        <ErrorModal
                            isOpen={showModal}
                            onRequestClose={() => {
                                setShowModal(false); // Close the modal
                                navigate("/adminhome"); // Redirect to /adminhome
                            }}
                            onReload={reloadData} // Pass reload function
                            message={errorMessage}
                        />

                        <div className={style.adminMainBodyBox} id="addBulkProductsBoxTop">
                            <AdminBreadCrump
                                title={"Add Bulk Stock Edit"}
                                companyName={"Loyalstring"}
                                module={"E-commerce"}
                                page={"Add Bulk Stock Edit"}
                            />
                            <div className="adminAddCategoryMainBox2-stock">


                                <div className={style.adminAddCategoryMainBox2stock}>
                                    <div className={style.adminAddCategoryMainBox2inner}>
                                        <div
                                            className={style.adminAddCategoryMainBox2inner2}
                                            onKeyDown={handleKeyDown}
                                        >




                                            {popupVisible && popupVisible === "stones" && (
                                                <SingleStonePopUp
                                                    itemlist={AddedProducts}
                                                    addStone={addStone}
                                                    index={selectedRow}
                                                    onClose={handleClosePopup}
                                                    onSave={handleSavePopup}
                                                    stonemaster={stonemaster}
                                                />
                                            )}

                                            {popupVisible && popupVisible === "diamonds" && (
                                                <SingleDiamondPopup
                                                    itemlist={AddedProducts}
                                                    addStone={addDiamond}
                                                    index={selectedRow}
                                                    onClose={handleClosePopup}
                                                    onSave={handleSavePopup}
                                                    allDiamondAttributes={allDiamondAttributes}
                                                />
                                            )}

                                            {popupVisible && popupVisible === "images" && (
                                                <Imagepopup
                                                    onClose={handleClosePopup}
                                                    itemlist={AddedProducts}
                                                    index={selectedRow} />

                                            )}

                                            <AddStockGridSection
                                                fields={itemfields}
                                                categoriesData={categoriesData}
                                                filteredProducts={filteredProducts}
                                                handlegriddropdown={handlegriddropdown}
                                                filteredDesigns={filteredDesigns}
                                                filteredPurity={filteredPurity}
                                                collectionmainlist={collectionmainlist}
                                                allPacketNumbers={allPacketNumbers}
                                                boxData={boxData}
                                                allSku={allSku}
                                                handlegridinput={handlegridinput}
                                                selectedImages2={selectedImages2}
                                                AddedProducts={AddedProducts}
                                                handleadditem={null}
                                                filteredSupplier={filteredSupplier}
                                                filteredsku={filterSku}
                                                setPopupVisible={setPopupVisible}
                                                handlepopup={handlepopup}
                                                setAddedProducts={setAddedProducts}
                                                getStonesBySKU={getStonesBySKU}
                                            />

                                        </div>

                                        <div
                                            className={
                                                style.adminAddCategoryMainBox2sectionHeaderlast
                                            }
                                        >
                                            <div className={style.buttonbox2}>
                                                <button
                                                    className={style.custombtn}
                                                    style={{ width: "24%" }}
                                                    onClick={saveall}
                                                >
                                                    {" "}
                                                    <Icon
                                                        style={{ fontSize: "24px" }}
                                                        icon="ic:outline-check"
                                                    />
                                                    Save All
                                                </button>



                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
                }
            </div>


        </div>

    )
}